export default __webpack_public_path__ + "static/media/iconFile.cb6c8b62.svg";